/**
 * The code an explicit send answers with when it reached no customer — an
 * operator's inbox reply, a validated draft, a workflow node's message whose
 * delivery attempt put nothing on the customer's channel.
 *
 * The message is still saved in the conversation, so the transcript alone
 * cannot tell a delivered reply from an undelivered one. This code is the only
 * signal a client has, which is why it lives here rather than as a literal on
 * each side of the wire: the backend's `ChannelDeliveryNotMadeError` declares
 * it as its `code`, and the inbox reads it to tell the operator.
 *
 * The HTTP status says WHY, and is the part a client branches on:
 *   409 — the channel cannot carry it (no handler, recipient, deployment or session)
 *   422 — the content was refused, empty, or refused by the channel
 *   502 — the provider rejected it
 */
export const CHANNEL_DELIVERY_NOT_MADE = "CHANNEL_DELIVERY_NOT_MADE";
